import { l } from '@manychat/manyui'

import { EngagementGoal, GoalStatus, GoalType } from 'shared/api/requests/aiEngagementGoal/schemas'

import { GoalTabs } from './types'

export const isActiveLeadQualGoal = (goal: EngagementGoal | null) => {
  return goal && goal.type === GoalType.LEAD_QUAL && goal.status === GoalStatus.ACTIVE
}

export const formTabsConfig = (goal: EngagementGoal | null, isMobile: boolean) => {
  const tabs = [
    {
      label: l.makeTranslate('Stats'),
      value: GoalTabs.STATS,
    },
    {
      label: l.makeTranslate('Setup'),
      value: GoalTabs.SETUP,
    },
  ]

  if (isMobile && goal) {
    tabs.push({ label: l.makeTranslate('Preview'), value: GoalTabs.PREVIEW })
  }

  return tabs
}
